

















import SurfaceHeader from 'vuecomponents/surface_header.vue'
import SurfacePost from 'vuecomponents/surface_post.vue'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { State, Getter, namespace } from 'vuex-class'
import GridMixin from 'vuemixins/grid_mixin'
import DoubleClickToPostMixin from 'vuemixins/double_click_to_post_mixin'
import PasteToPostMixin from 'vuemixins/paste_to_post_mixin'
import DropToPostMixin from 'vuemixins/drop_to_post_mixin'

const browser = namespace('browser')

@Component({
  components: {
    SurfaceHeader,
    SurfacePost,
  },
  mixins: [GridMixin, DoubleClickToPostMixin, PasteToPostMixin, DropToPostMixin],
})
export default class SurfaceContainerGrid extends Vue {
  @State xHeader
  @State inlinePostEdit
  @Getter isPostable
  @browser.Getter windowWidth
  @(namespace('post').Getter) sortedPosts
  @(namespace('post').Action) sortedPost
  initializeGrid!: (
    node: Node,
    savePostHandler: (data: { postCid; sectionId: never; previousCid; nextCid }) => void,
  ) => void // from GridMixin
  debouncedUpdateGrid!: () => void // from GridMixin
  enableDoubleClickToPost!: (wallContainer: Element, wishList: Element) => void // from DoubleClickToPostMixin
  disableDoubleClickToPost!: (wallContainer: Element) => void // from DoubleClickToPostMixin
  enablePasteToPost!: () => void // from PasteToPostMixin
  disablePasteToPost!: () => void // from PasteToPostMixin
  enableDropToPost!: (wallContainer: Element) => void // from DropToPostMixin
  disableDropToPost!: (wallContainer: Element) => void // from DropToPostMixin

  mounted() {
    this.initializeGrid(
      this.$refs.wallContainer as Node,
      (data: { postCid; sectionId: never; previousCid; nextCid }) => {
        this.sortedPost(data)
      },
    )

    if (this.isPostable) {
      this.enableNewPostHandlers()
    }
  }

  beforeDestroy() {
    this.disableNewPostHandlers()
  }

  enableNewPostHandlers() {
    this.enableDoubleClickToPost(this.$el, this.$refs.wishList as Element)
    this.enablePasteToPost()
    this.enableDropToPost(this.$el)
  }

  disableNewPostHandlers() {
    this.disableDoubleClickToPost(this.$el)
    this.disablePasteToPost()
    this.disableDropToPost(this.$el)
  }

  @Watch('isPostable')
  toggleNewPostHandlers(newValue) {
    newValue ? this.enableNewPostHandlers() : this.disableNewPostHandlers()
  }

  @Watch('windowWidth')
  updateGridOnWindowWidthChange() {
    this.debouncedUpdateGrid()
  }
}
